<div class="bh-block">
    <h2 class="bh-block-title">Still have a question?</h2>
    <p class="bh-block-subtitle">If you cannot find the answer to your question in our FAQ, you can always contact us.</p>
    <div class="bh-block-supports">
        <div class="bh-block-support-card">
            <img ngSrc="assets/images/icons/icon_contact1.svg" alt="" width="40" height="40">
            <p>929-500-ARGO</p>
            <span>We are always happy to help.</span>
        </div>
        <div class="bh-block-support-card">
            <img ngSrc="assets/images/icons/icon_contact2.svg" alt="" width="40" height="40">
            <p>info@argoprep.com</p>
            <span>Alternative way to reach us.</span>
        </div>
    </div>
</div>
